(function () {
  'use strict';

  if (window.FlorameRUM) return;

  var script = document.currentScript;
  var endpoint = script?.dataset?.florameRumEndpoint || 'https://us-central1-flower-ai-2d7aa.cloudfunctions.net/logEvent';
  var release = String(script?.dataset?.florameRelease || '').slice(0, 40);
  var sessionKey = 'florame_rum_session_v1';
  var apiEvents = 0;
  var runtimeSession = '';
  var route = location.pathname + location.search;
  var latest = { LCP: 0, CLS: 0, INP: 0 };
  var flushed = new Set();
  var viewport = '';
  var telemetryUrl;
  var incidentEvents = 0;
  try { telemetryUrl = new URL(endpoint, location.href); } catch (_) {}
  addEventListener('resize', function () { viewport = ''; }, { passive: true });

  function viewportSize() {
    if (!viewport) viewport = Math.round(innerWidth) + 'x' + Math.round(innerHeight);
    return viewport;
  }

  function allowed() {
    try { return window.FloramePrivacy?.analyticsAllowed?.() === true; } catch (_) { return false; }
  }

  function sessionId() {
    if (!allowed()) return '';
    if (runtimeSession) return runtimeSession;
    try {
      var current = sessionStorage.getItem(sessionKey);
      if (current) return (runtimeSession = current);
      current = window.crypto?.randomUUID?.() || ('rum_' + Date.now().toString(36) + Math.random().toString(36).slice(2));
      runtimeSession = current;
      sessionStorage.setItem(sessionKey, current);
      return current;
    } catch (_) {
      return runtimeSession || (runtimeSession = 'rum_' + Date.now().toString(36) + Math.random().toString(36).slice(2));
    }
  }

  function clean(value, max) {
    return String(value || '').replace(/https?:\/\/\S+/gi, '[url]').replace(/[\r\n]+/g, ' ').slice(0, max || 180);
  }

  function partnerSlug() {
    try {
      return String(window.FloramePartner?.getAttributionMeta?.()?.partnerSlug || document.documentElement.dataset.floramePartnerSlug || '').slice(0, 120);
    } catch (_) { return ''; }
  }

  function send(eventType, extra) {
    var sid = sessionId();
    if (!sid) return false;
    var body = {
      event_type: eventType,
      event_name: eventType,
      session_id: sid,
      partnerSlug: partnerSlug(),
      page: location.pathname,
      extra: Object.assign({
        surface: 'storefront',
        release: release,
        route: location.pathname,
        viewport: viewportSize(),
      }, extra || {}),
    };
    try {
      var payload = JSON.stringify(body);
      if (navigator.sendBeacon && document.visibilityState === 'hidden') {
        return navigator.sendBeacon(endpoint, new Blob([payload], { type: 'application/json' }));
      }
      fetch(endpoint, {
        method: 'POST',
        keepalive: true,
        credentials: 'omit',
        headers: { 'Content-Type': 'application/json' },
        body: payload,
      }).catch(function () {});
      return true;
    } catch (_) { return false; }
  }

  function rating(name, value) {
    if (name === 'LCP') return value <= 2500 ? 'good' : value <= 4000 ? 'needs-improvement' : 'poor';
    if (name === 'INP') return value <= 200 ? 'good' : value <= 500 ? 'needs-improvement' : 'poor';
    return value <= 0.1 ? 'good' : value <= 0.25 ? 'needs-improvement' : 'poor';
  }

  var authKey = 'florame_rum_auth_observation_v1';
  var logoutRequested = false;
  function clearAuthMarker() {
    try { localStorage.removeItem(authKey); } catch (_) {}
  }
  function observeShopifySession(authenticated, confirmed) {
    if (!allowed()) { clearAuthMarker(); return; }
    if (logoutRequested) return;
    var now = Date.now(), previous = null;
    var appVersion = String(navigator.userAgent || '').match(/FlorameAndroid\/([\d.]{1,24})(?:\s|$)/)?.[1] || '';
    try { previous = JSON.parse(localStorage.getItem(authKey) || 'null'); } catch (_) {}
    var age = now - Number(previous?.seenAt);
    if (!Number.isFinite(age) || age < 0 || age > 366 * 86400000) previous = null;
    if (authenticated === true) {
      try { localStorage.setItem(authKey, JSON.stringify({ seenAt: now, release: release, appVersion: appVersion })); } catch (_) {}
      return;
    }
    if (!confirmed || authenticated !== false) return;
    if (previous) send('rum_auth_session_lost', {
      elapsedSeconds: Math.floor(age / 1000), appVersion: appVersion,
      previousRelease: /^v\.\d+\.\d+\.\d+$/.test(previous.release || '') ? previous.release : '',
      previousAppVersion: /^[\d.]{1,24}$/.test(previous.appVersion || '') ? previous.appVersion : ''
    });
    clearAuthMarker();
  }
  function observeRenderedSession() {
    var root = document.querySelector?.('[data-florame-account-center]');
    if (root) observeShopifySession(root.getAttribute('data-authenticated') === 'true', false);
    else if (!allowed()) clearAuthMarker();
  }
  function onAuthObservation(event) {
    var source = event.detail?.source;
    if (source === 'shopify-server' || source === 'signed-proxy') observeShopifySession(event.detail.authenticated, source === 'signed-proxy');
  }
  addEventListener('florame:auth-state', onAuthObservation);
  addEventListener('florame:auth-confirmed', onAuthObservation);
  addEventListener('florame:auth-logout', function () { logoutRequested = true; clearAuthMarker(); });
  document.addEventListener('visitorConsentCollected', observeRenderedSession);
  window.FloramePrivacy?.onAnalyticsAllowed?.(observeRenderedSession);
  observeRenderedSession();

  function flushVitals() {
    Object.entries(latest).forEach(function (entry) {
      var name = entry[0];
      var value = entry[1];
      if (!value || flushed.has(name)) return;
      if (send('rum_web_vital', { metric: name, value: Math.round(value * 1000) / 1000, rating: rating(name, value) })) flushed.add(name);
    });
  }

  function observe(type, callback) {
    try { new PerformanceObserver(callback).observe({ type: type, buffered: true }); } catch (_) {}
  }

  observe('largest-contentful-paint', function (list) {
    var entries = list.getEntries();
    latest.LCP = entries.length ? entries[entries.length - 1].startTime : latest.LCP;
  });
  observe('layout-shift', function (list) {
    list.getEntries().forEach(function (entry) { if (!entry.hadRecentInput) latest.CLS += entry.value; });
  });
  observe('event', function (list) {
    list.getEntries().forEach(function (entry) { if (entry.interactionId && entry.duration > latest.INP) latest.INP = entry.duration; });
  });
  observe('resource', function (list) {
    if (!allowed() || apiEvents >= 20) return;
    list.getEntries().forEach(function (entry) {
      if (apiEvents >= 20 || !/cloudfunctions\.net|\.myshopify\.com/i.test(entry.name)) return;
      var parsed;
      try { parsed = new URL(entry.name); } catch (_) { return; }
      // Monitoring its own delivery would generate a chain of new timing events.
      if (telemetryUrl && parsed.origin === telemetryUrl.origin && parsed.pathname === telemetryUrl.pathname) return;
      apiEvents += 1;
      send('rum_api_timing', {
        api: clean(parsed.pathname.split('/').filter(Boolean).pop() || parsed.hostname, 80),
        durationMs: Math.round(entry.duration),
        initiator: clean(entry.initiatorType, 30),
      });
    });
  });

  function reportNavigation() {
    try {
      var nav = performance.getEntriesByType('navigation')[0];
      if (!nav) return;
      send('rum_navigation', {
        ttfbMs: Math.round(nav.responseStart),
        domContentLoadedMs: Math.round(nav.domContentLoadedEventEnd),
        loadMs: Math.round(nav.loadEventEnd || performance.now()),
        transferBytes: Math.round(nav.transferSize || 0),
      });
    } catch (_) {}
  }

  function routeChanged(source) {
    var next = location.pathname + location.search;
    if (next === route) return;
    var previous = route;
    route = next;
    send('rum_route_change', { source: source, from: clean(previous, 240), to: clean(next, 240) });
  }

  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    if (typeof original !== 'function') return;
    history[method] = function () {
      var result = original.apply(this, arguments);
      routeChanged(method);
      return result;
    };
  });
  addEventListener('popstate', function () { routeChanged('popstate'); });
  function ownedScript(value) {
    try { var url = new URL(String(value || '').replace(/:\d+(?::\d+)?$/, ''), location.href), source = url.pathname.split('/').pop(); return { source: source, ownedSource: /\.m?js$/.test(source) && (url.origin === location.origin || /(^|\.)shopify\.com$/.test(url.hostname) && /^(florame-|delivery-scheduler|cart(?:\.|-)|awi-)/.test(source)) }; } catch (_) { return { ownedSource: false }; }
  }
  function runtimeError(event, rejection) {
    if (incidentEvents >= 30) return;
    var reason = rejection ? event.reason : event.error, asset = event.target?.tagName === 'SCRIPT' ? event.target.src : '', source = event.filename || asset || String(reason?.stack || '').match(/https?:\/\/[^\s)]+/)?.[0] || '', owned = ownedScript(source);
    if (!owned.ownedSource) return;
    incidentEvents += 1;
    send('rum_javascript_error', Object.assign({kind: rejection ? 'unhandledrejection' : 'error', name: asset ? 'ChunkLoadError' : clean(reason?.name || 'Error',60), message: asset ? 'Owned script failed to load' : clean(event.message || reason?.message || reason,180)},owned));
  }
  addEventListener('error', function (event) { runtimeError(event, false); }, true);
  addEventListener('unhandledrejection', function (event) {
    runtimeError(event, true);
  });
  document.addEventListener('florame:flow-failure', function (event) {
    send('rum_flow_failure', { flow: clean(event.detail?.flow, 80), step: clean(event.detail?.step, 80), errorCode: clean(event.detail?.errorCode || event.detail?.code, 80) });
  });
  addEventListener('load', function () { setTimeout(reportNavigation, 0); }, { once: true });
  addEventListener('pagehide', flushVitals);
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flushVitals(); });

  window.FlorameRUM = Object.freeze({ track: send, flowFailure: function (detail) { send('rum_flow_failure', {flow:clean(detail?.flow,80),step:clean(detail?.step,80),errorCode:clean(detail?.errorCode || detail?.code,80)}); }, flushVitals: flushVitals });
  // Observe the original request/result without reading bodies, retrying, changing
  // headers or blocking the purchase. Expected validation responses aren't faults.
  var nativeFetch = window.fetch;
  window.fetch = function (input, init) {
    var step = '', method = String(init?.method || input?.method || 'GET').toUpperCase();
    try { var url = new URL(input?.url || String(input), location.href), match = url.pathname.match(/^\/(?:en\/|it\/)?cart(?:\/(add|change|update))?\.js$/);if (url.origin === location.origin && match) step = match[1] ? 'cart_' + match[1] : 'cart_read';else if (/^https:\/\/us-central1-flower-ai-2d7aa\.cloudfunctions\.net\/saveDeliveryData$/.test(url.origin + url.pathname) && method === 'POST') step = 'delivery_validation'; } catch (_) {}
    var work = nativeFetch.apply(this, arguments);
    if (!step) return work;
    function report(ok, code) { try { if (incidentEvents >= 30 || !allowed()) return;incidentEvents += 1;send(ok ? 'rum_flow_success' : 'rum_flow_failure',{flow:'purchase',step:step,errorCode:code}); } catch (_) {} }
    return work.then(function (response) { if (response.status >= 500 && step !== 'delivery_validation') report(false,'HTTP_' + response.status);return response; }, function (error) { if (error?.name !== 'AbortError' && navigator.onLine !== false) report(false,'NETWORK_REQUEST_FAILED');throw error; });
  };
})();
